<template id="productShelf">
    <section id="product">
        <bulkModal :common_res="common_res" :res="res" :id="'bulkbox'"></bulkModal>
        <bulkListModal :common_res="common_res" :res="res" :id="'bulklistbox'"></bulkListModal>
        <processingOrderListModal :common_res="common_res" :res="res" :id="'porderlistbox'"></processingOrderListModal>
        <div class="b2b_shelf_flyout" role="tooltip">
            <div class="b2b_shelf_flyout_contents" v-if="showing_product != null">
                <!--
                <shelfProduct :fmt="2" :common_res="common_res" :res="res" :details="showing_product" :stock="showing_product.stock" :iqty="showing_product.iqty" :idx="0" />
                -->
                <orderProduct :fmt="showing_product.ratedp" :common_res="common_res" :res="res" :details="showing_product" :stock="getProductStock(showing_product)" :iqty="getCartQty(showing_product)" :idx="0"/>
            </div>
            <div class="b2b_shelf_flyout_arrow"></div>
            <div :class="'b2b_shelf_flyout_progress'+(showing_product.is_loading? ' active':'')">
                <i class="fa fa-fw fa-refresh fa-spin spinner"></i>
            </div>
        </div>

        <div class="b2b_shelfs_bar">
            <div class="container">
                <div class="b2b_shelfs_bar_left filters">
                <!--
                    <a href="#" class="filters_toggle" data-toggle="collapse" data-target="#filters_container">Filter<i class="fa fa-chevron-down"></i></a>
                    <div class="filters_container collapse" id="filters_container">
                        <a href="#" class="redtag"><img src="images/staricon.png" alt="image">New</a>
                        <a href="#"><img src="images/salesicon.png" alt="image">Sales</a>
                        <a href="#"><img src="images/sellingicon.png" alt="image">Best Selling</a>
                    </div>
                -->
                </div>
                <div class="b2b_shelfs_bar_right">
                    <a v-if="isProductList" href="../product/index.html" class="btn submitButton switchViewButton"><i class="fa fa-list-ul"></i> {{ common_res.switch_view }}</a>
                    <!--
                    <a class="btn submitButton resetViewButton"><i class="fa fa-refresh"></i> {{ common_res.reset_view }}</a>
                    -->
                    <a href="javascript:void(0)" v-on:click="openBulk" class="btn submitButton resetViewButton enterdata"><i class="fa fa-keyboard-o"></i><span class="btn_text">{{res.enterbulk}}</span></a>
                    <a class="btn submitButton" href="../cart/index.html"><i class="fa fa-check"></i> {{ common_res.confirm_order }}</a>
                </div>
            </div>
        </div>
        <!--shelfProduct :fmt="2" :common_res="common_res" :res="res" :details="showing_product" :stock="showing_product.stock" :iqty="showing_product.iqty" :idx="0" /-->
        <div class="b2b_shelfs">
            <div class="b2b_shelfs_wrapper" 
                v-on:dblclick.stop.prevent="downloadShelfsXls($event)" 
                v_on_dblclick_stop_prevent="downloadProductsSeq($event)"
                v-on:drop.stop.prevent="setProductsSeq($event)" v-on:dragover="$event.preventDefault()">
                <div class="b2b_shelf" v-for="(shelf, shelf_idx) in shelfs" :idx="shelf_idx">
                    <div class="b2b_shelf_title">{{ shelf.title }}</div>
                    <div class="b2b_shelf_container">
                        <div class="b2b_shelf_bg">
                            <picture>
                                <source srcset="/b2b/images/shelf/bg-shelf@2x.webp" type="image/webp">
                                <source srcset="/b2b/images/shelf/bg-shelf@2x.png" type="image/png">
                                <img src="/b2b/images/shelf/bg-shelf@2x.png">
                            </picture>
                        </div>
                        <div class="b2b_shelf_storage">
                            <div class="b2b_shelf_row" v-for="(layer, layer_idx) in shelf.layers" :idx="layer_idx"
                                :layer_highest="layer.layer_highest != null?layer.highest_product.id:null" v-on:dragover="$event.preventDefault()"
                                v-on:drop.stop.prevent="setLayerProduct($event, layer, shelf_idx, layer_idx)"
                                v-on:dblclick.stop.prevent="_downloadLayer($event, layer, shelf_idx, layer_idx)">
                                <div class="b2b_shelf_row_contents">
                                    <template v-for="(product, product_idx) in layer.products">
                                        <div class="b2b_shelf_product_wrap" v-if="product.id != '0' && product.id != '00'"
                                            v-on:dragend.stop.prevent="doneMoved($event, product)">
                                            <div :pid="product.id" class="b2b_shelf_pricetag_wrapper" v-if="product.dollar">
                                                <div class="b2b_shelf_pricetag"><sup>$</sup>{{ product.dollar }}<sup>.{{
                                                    product.cent }}</sup></div>
                                            </div>
                                            <div :stock="product.stock" :pwidth="product.pwidth" :pheight="product.pheight" :pid="product.id"
                                                class="b2b_shelf_product" v-on:click="touchProduct(product)"
                                                v-on:dragover="$event.preventDefault()"
                                                v-on:drop.stop.prevent="setProduct($event, product, shelf_idx, layer_idx, product_idx)"
                                                v-on:mouseenter="touchProduct(product)">
                                                <img v-if="product.img != null" :src="product.img.src" :style="'--width:' + product.width + 'px;'+(product.stock==0?'filter: grayscale(100%);':'')">
                                                <img v-else :src="product.image" :style="'--width:' + product.width + 'px;'+(product.stock==0?'filter: grayscale(100%);':'')">
                                            </div>
                                        </div>
                                        <div class="b2b_shelf_product_wrap" v-if="product.new != null">
                                            <div class="b2b_shelf_talker">
                                                <div class="b2b_shelf_talker_overlay">
                                                    <div class="b2b_shelf_talker_contents new">
                                                        <div class="talker_title">NEW</div>
                                                        <div class="talker_contents"><span class="talker_year">{{  product.new.split(' ')[0] }}</span><span class="talker_monthday">{{ product.new.split(' ')[1] }}</span></div>
                                                    </div>
                                                </div>
                                                <img src="/b2b/images/shelf/talker-shelf-new.png" style="--width: 213px;">
                                            </div>
                                        </div>
                                        <template v-if="product.placeholder!= null">
                                            <div v-for="num in parseInt(product.placeholder)" :n="num" class="b2b_shelf_blank_placeholder"></div>
                                        </template>
                                        <div class="b2b_shelf_product_wrap" v-if="product.top != null">
                                            <div class="b2b_shelf_talker">
                                                <div class="b2b_shelf_talker_overlay">
                                                    <div class="b2b_shelf_talker_contents top">
                                                        <div class="talker_title">TOP</div>
                                                        <div class="talker_contents">{{ product.top }}</div>
                                                    </div>
                                                </div>
                                                <img :src="'/b2b/images/shelf/talker-shelf-top'+(product.top<=3?product.top:3)+'.png'" style="--width: 213px;">
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="b2b_shelf_lightbox" v-on:dragover="$event.preventDefault()"
                            v-on:drop.stop.prevent="setShelfProduct($event, shelf, shelf_idx)"
                            v-on:dblclick.stop.prevent="_downloadShelf($event, shelf, shelf_idx)">
                            <picture v-if="shelf.banner != null && shelf.banner.indexOf('.') < 0">
                                <source
                                    :srcset="shelf.banner+'.webp 1x, ' + shelf.banner+'@2x.webp 2x'"
                                    type="image/webp">
                                <source
                                    :srcset="shelf.banner+'.jpg 1x, ' + shelf.banner+'@2x.jpg 2x'"
                                    type="image/jpg">
                                <img :src="shelf.banner+'.jpg'">
                            </picture>
                            <picture v-else-if="shelf.banner != null">
                                <source
                                    :srcset="shelf.banner+ ' 1x, ' + shelf.banner.substring(0, shelf.banner.indexOf('.'))+'@2x' + shelf.banner.substring(shelf.banner.indexOf('.')) + ' 2x'"
                                    type="image/webp">
                                <img :src="shelf.banner">
                            </picture>
                            <!--
                            <picture>
                                <source
                                    srcset="/b2b/images/shelf/lightbox/lightbox-sagami.webp 1x, /b2b/images/shelf/lightbox/lightbox-sagami@2x.webp 2x"
                                    type="image/webp">
                                <source
                                    srcset="/b2b/images/shelf/lightbox/lightbox-sagami.jpg 1x, /b2b/images/shelf/lightbox/lightbox-sagami@2x.jpg 2x"
                                    type="image/jpg">
                                <img src="/b2b/images/shelf/lightbox/lightbox-sagami.jpg">
                            </picture>
                            -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="b2b_shelfs_control" v-if="shelfs != null && shelfs.length > 0">
                <div class="b2b_shelfs_control_wrapper direction">
                    <div class="b2b_shelfs_control_container left">
                        <a class="b2b_shelfs_control_button moveleft"><i class="fa fa-chevron-left"></i></a>
                    </div>
                    <div class="b2b_shelfs_control_container middle">
                        <a class="b2b_shelfs_control_button moveup"><i class="fa fa-chevron-up"></i></a>
                        <a class="b2b_shelfs_control_button reset"><i class="fa fa-window-maximize"></i></a>
                        <a class="b2b_shelfs_control_button movedown"><i class="fa fa-chevron-down"></i></a>
                    </div>
                    <div class="b2b_shelfs_control_container right">
                        <a class="b2b_shelfs_control_button moveright"><i class="fa fa-chevron-right"></i></a>
                    </div>
                </div>
                <div class="b2b_shelfs_control_wrapper zoom">
                    <div class="b2b_shelfs_control_container middle">
                        <a class="b2b_shelfs_control_button zoomin"><i class="fa fa-plus"></i></a>
                        <a class="b2b_shelfs_control_button zoomout"><i class="fa fa-minus"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import utils from './Utils.vue'
import orderProduct from './OrderProduct.vue'
//import shelfProduct from './ShelfProduct.vue'
//import shelfProduct from './OrderProduct.vue'
import productList from './ProductList.vue'
import bulkModal from './BulkModal.vue'
import bulkListModal from './BulkListModal.vue'
import processingOrderListModal from './ProcessingOrderListModal.vue'
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCookie from 'vue-cookie';
import { id } from 'html-webpack-plugin/lib/chunksorter'
Vue.use(VueResource);
Vue.use(VueCookie);
var months = {'01':'JAN', '02':'FEB', '03':'MAR', '04':'APR', '05':'MAY', '06':'JUN', '07':'JUL', '08':'AUG', '09':'SEP', '10':'OCT', '11':'NOV', '12':'DEC'};

var talkers = ['top', 'placeholder', 'new']
var PRODUCT_IMG_EXT = ".webp";
var IMAGE_SERVER = "https://www.sampsonstore.com";
export default {
    extends: productList,
    name: 'productShelf',
    props: ['name', 'clients', 'firstamts', 'countries', 'common_res', 'res', 'order_processing', 'pdiscounts', 'shelf_mode'],
    data() {
        return {
            default_banner: '/b2b/images/shelf/lightbox/lightbox-sagami',
            products_list_url: '/b2b/json/planogram.json',
            showing_product: { 'pdetails': {}, 'stock': 0 },
            shelfs: null,
            touching: -1,
            all_products_list: null,
            top_list: [],
            new_list: [],
            width_to_pixel: 2.835,
            shelf_width: 890,
            shelf_height: 1070,
            layers_num: 5,
            products_loading: null,
            products_in_seq: [],
            all_loaded: false,
            check_display: false,
            missing_images:[],
            products_loaded: [],
            orientation: null,
            editing: true,
            loaded: [0, 0],
            delimiter: '|'
        }
    },
    computed: {
        isProductList:function() {
            if (this.shelf_mode == undefined || this.shelf_mode == null) return true;
            if (parseInt(this.shelf_mode) == 0) return true;
            if (this.shelf_mode.substring(1, 2) == '1') return true;
            return false;
        },
        isPog:function() {
            if (this.shelf_mode == undefined || this.shelf_mode == null) return false;
            if (this.shelf_mode.substring(0, 1) == '1') return true;
            return false;
        },
        isEditing:function() {
            console.log('editing', this.shelf_mode, this.shelf_mode.substring(2, 3));
            if (this.shelf_mode.substring(2, 3) == '1') return true;
            return false;
        }
    },
    components: {
        orderProduct,
        bulkModal,
        bulkListModal,
        processingOrderListModal
    },
    created: function () {
        var self = this;
        self.orientation = utils.getParam('orientation');
        //document.body.style.overflowY = 'hidden';
        /*
        var num = 2000;
        var start = 0;
        var url = "search.is?only_id=true&product_name=&start=" + start + "&num=" + num;
        Vue.http.get(utils.getServerPath() + '/product/' + url).then(response => {
            self.all_products_list = response.body.productlist;
            console.log(self.all_products_list);
        });
        */
    },
    methods: {
        convertJSONToSeq: function (shelfs_info) {
            var self = this;
            var seq = []
            for (var i=0;i<shelfs_info.length;i++) {
                var shelf = shelfs_info[i];
                seq.push('00' + self.delimiter + shelf['title'][0] + self.delimiter + shelf['banner'][0]);
                for (var j=0;j<shelf['products'].length;j++) {
                    var p = shelf.products[j];
                    seq.push(''+p)
                }
            }
            return seq;
        },
        constructShelfs: function (productlist, name_prefix, banner_image) {
            var self = this;
            self.products_in_seq = []
            var shop = { "shelfs": [] };
            //shop.shelfs.push({ "banner":self.default_banner, "title": name_prefix + " " + (shop.shelfs.length), 'layers': [] })
            shop.shelfs.push({ "banner":banner_image!=null?banner_image:self.default_banner, "title": name_prefix + " " + (''), 'layers': [] })
            var total_width = 0;
            var total_height = 0;
            var layer_highest = 0;
            var layer = { "products": [] };
            shop.shelfs[shop.shelfs.length - 1].layers.push(layer);
            for (var i = 0; i < productlist.length; i++) {
                var shelfname = null;
                var shelfbanner = banner_image!=null?banner_image:self.default_banner;
                var p = productlist[i];
                if (p.pdetails != null) p.product_name = p.pdetails.product_name;
                if (p.pheight != null) p.height = p.pheight;
                if (p.pwidth != null) p.width = p.pwidth;
                var layer_break = false;
                var shelf_break = false;
                var w = 0, h = 0;
                if (p.id == '0') {
                    layer_break= true;
                    self.products_in_seq.push(p.id);
                    // just do nothing if first element
                    if (i == 0) continue;
                } else if (p.id == '00') {
                    layer_break= true;
                    shelf_break= true;
                    if (p.name != null) {
                        shelfname = p.name;
                        if (p.banner != null) {
                            shelfbanner = p.banner;
                        }
                    }
                    var pline = p.id;
                    if (p.name != null) pline = pline + self.delimiter + p.name;
                    if (p.banner != null) pline = pline + self.delimiter + p.banner;
                    self.products_in_seq.push(pline);
                    // just do nothing if first element
                    // for future, the first line of 00 can include the image and title
                    if (i == 0) {
                        if (shelfname != null) {
                            shop.shelfs[0].title = shelfname;
                            shelfname = null;
                        }
                        if (shelfbanner != null) {
                            shop.shelfs[0].banner = shelfbanner;
                            shelfbanner = banner_image!=null?banner_image:self.default_banner;
                        }
                        continue;
                    }
                } else if (isNaN(parseFloat(p.id))) {
                    self.products_in_seq.push(pline);
                    if (p.id == null) {
                        p = {"id":p}
                        productlist[i] = p;
                    }
                    w = 70;
                    total_width = total_width + w;
                    if (p.id.startsWith("xxtop")) {
                        if (total_width + w + productlist[i+1].width * 2 > self.shelf_width) layer_break = true;
                    } else if (p.id.startsWith("placeholder")) {
                        if ((total_width + w) > self.shelf_width) {
                            layer_break = true;
                            p.id = 'placeholder|0';
                        }
                    } else if (p.id.startsWith("new") || p.id.startsWith("top")) {
                        var tmp_width = 0;
                        for (var j=i+1;j<productlist.length;j++) {
                            var tmpp = productlist[j];
                            if (tmpp.id != null) tmpp = tmpp.id;
                            if (tmpp.startsWith('placeholder')) {
                                break;
                            } else {
                                tmp_width = tmp_width + parseFloat(productlist[j].width);
                            }
                        }
                        if ((total_width + tmp_width) > self.shelf_width) {
                            layer_break = true;
                        }
                    }
                } else {
                    if (p.id == null) {
                        self.products_in_seq.push(p.pdetails.product_id);
                        w = parseFloat(p.pdetails.width);
                        h = parseFloat(p.pdetails.height);
                        p.width = w;
                        p.height = h;
                    } else {
                        self.products_in_seq.push(p.id);
                        w = parseFloat(p.width);
                        h = parseFloat(p.height);
                    }
                    if (isNaN(w) || w <= 1) {
                        w = 200;
                    }
                    if (isNaN(h) || h <= 1) {
                        h = 200;
                    }
                    if ((self.orientation == 'portrait' && w > h) || self.orientation == 'landscape' && h > w) {
                        // convert to landscape
                        var t = w;
                        w = h;
                        h = t;
                        t = p.width;
                        p.width = p.height;
                        p.height = t;
                    }
                    total_width = total_width + w
                }
                //console.log(p.id, w, h);
                if (total_width > self.shelf_width) {
                    layer_break = true;
                }
                //console.log(total_width, p.small_obj, p.pdetails.width, p.pdetails.product_name, p.pdetails.product_id);
                if (layer_break) {
                    total_height = total_height + layer_highest;
                    console.log(shop.shelfs.length - 1, total_height, shop.shelfs[shop.shelfs.length - 1].layers.length - 1, layer_highest, h, layer);
                    //if (shop.shelfs[shop.shelfs.length-1].layers == null) {
                    //    shop.shelfs[shop.shelfs.length-1].layers = []
                    //}
                    //if (shop.shelfs[shop.shelfs.length-1].layers.length >= self.layers_num) {
                    if (w == 0) {
                        //layer.products.push({"id":p.id});
                        layer.products.push(JSON.parse(JSON.stringify(p)));
                    }
                    if (total_height > self.shelf_height || shelf_break) {
                        if (total_height > self.shelf_height) {
                            var players = shop.shelfs[shop.shelfs.length - 1].layers.pop();
                            //shop.shelfs.push({ "banner":self.default_banner, "title": name_prefix + " " + (shop.shelfs.length), 'layers': [players] })
                            shop.shelfs.push({ "banner":banner_image!=null?banner_image:self.default_banner, "title": name_prefix + " " + (''), 'layers': [players] })
                            total_height = layer_highest;
                        }
                        if (shelf_break) {
                            if (shelfname != null && shelfbanner != null) {
                                shop.shelfs.push({ "title": shelfname, "banner": shelfbanner, 'layers': [] })
                                shelfname = null;
                                shelfbanner = banner_image!=null?banner_image:self.default_banner;
                            } else if (shelfname != null) {
                                shop.shelfs.push({ "banner":banner_image!=null?banner_image:self.default_banner, "title": shelfname, 'layers': [] })
                                shelfname = null;
                            } else {
                                //shop.shelfs.push({ "banner":self.default_banner, "title": name_prefix + " " + (shop.shelfs.length), 'layers': [] })
                                shop.shelfs.push({ "banner":banner_image!=null?banner_image:self.default_banner, "title": name_prefix + " " + (''), 'layers': [] })
                            }
                            total_height = 0;
                        } else {
                            //var players = shop.shelfs[shop.shelfs.length - 1].layers.pop();
                            //shop.shelfs.push({ "banner":self.default_banner, "title": name_prefix + " " + (shop.shelfs.length), 'layers': [players] })
                            //total_height = layer_highest;
                        }
                    }
                    layer_highest = h;
                    total_width = w;
                    if (w == 0) {
                        // means it is just a breaker
                        layer = {"products":[]}
                    } else {
                        if (isNaN(parseFloat(p.id))) {
                            var talker_info = p.id.split(self.delimiter);
                            var obj = {};
                            obj[talker_info[0]] = talker_info[1];
                            layer = { "products": [obj]};
                        } else {
                            layer = { "products": [{ "is_new":p.is_new, "rank":p.is_top, "stock":p.stock, "wfreen":p.wfreen, "wbuym":p.wbuym, "pdetails":{"product_id":p.id, "price":p.price, "product_name":p.product_name}, "image":p.image, "id": p.id, "width": w * self.width_to_pixel, "pwidth": p.width, "pheight": p.height, "price":p.price }] };
                        }
                        layer.highest_product = { "id": p.id};
                    }
                    shop.shelfs[shop.shelfs.length - 1].layers.push(layer);
                } else {
                    if (h > layer_highest) {
                        layer_highest = h;
                        layer.highest_product = { "id": p.id};
                    }
                    if (isNaN(parseFloat(p.id))) {
                        var talker_info = p.id.split(self.delimiter);
                        var obj = {};
                        obj[talker_info[0]] = talker_info[1];
                        layer.products.push(obj);
                    } else {
                        layer.products.push({ "is_new":p.is_new, "rank":p.is_top, "stock":p.stock, "wfreen":p.wfreen, "wbuym":p.wbuym, "pdetails":{"product_id":p.id, "price":p.price, "product_name":p.product_name}, "image":p.image, "id": p.id, "width": w * self.width_to_pixel, "pwidth": p.width, "pheight": p.height, "price":p.price });
                    }
                }
            }
            // handle the last few products on the shelf
            total_height = total_height + layer_highest;
            if (total_height > self.shelf_height) {
                var players = shop.shelfs[shop.shelfs.length - 1].layers.pop();
                //console.log('shelf ', total_width, shop.shelfs.length);
                //shop.shelfs.push({ "banner":self.default_banner, "title": name_prefix + " " + (shop.shelfs.length), 'layers': [players] })
                shop.shelfs.push({ "banner":banner_image!=null?banner_image:self.default_banner, "title": name_prefix + " " + (''), 'layers': [players] })
            }
            console.log("shop", shop);
            console.log("products_in_seq", self.products_in_seq);
            return shop;
        },
        setupShelfs: function (tmp_shelfs, is_config) {
            var self = this;
            try {
                document.getElementById("floating_js").remove();
            } catch (e) {
            }
            self.products_in_seq = [];
            var all_products = [];
            var fetch_products = [];

            if (self.new_list.length > 0) {
                for (var i=tmp_shelfs.shelfs.length-1;i>=0;i--) {
                    var shelf = tmp_shelfs.shelfs[i];
                    if (shelf.title.toLowerCase().trim() == 'new') {
                        tmp_shelfs.shelfs.splice(i, 1);
                    }
                }
                var newShelf = self.constructShelfs(self.new_list, 'New', '/b2b/images/shelf/lightbox/lightbox-top-new');
                for (var i=0;i<newShelf.shelfs.length;i++) {
                    //tmp_shelfs.shelfs.splice(0, 0, newShelf.shelfs[i]);
                }
            }
            if (self.top_list.length > 0) {
                for (var j=0;j<self.top_list.length;j+=4) {
                    self.top_list[j] = {"id":"top|" + ((j/4)+1)};
                }
                for (var i=tmp_shelfs.shelfs.length-1;i>=0;i--) {
                    var shelf = tmp_shelfs.shelfs[i];
                    if (shelf.title.toLowerCase().trim() == 'top') {
                        tmp_shelfs.shelfs.splice(i, 1);
                    }
                }
                var topShelf = self.constructShelfs(self.top_list, 'Top', '/b2b/images/shelf/lightbox/lightbox-top-new');
                for (var i=0;i<topShelf.shelfs.length;i++) {
                    //tmp_shelfs.shelfs.splice(0, 0, topShelf.shelfs[i]);
                }
                //self.top_list.push({"id":'0'});
            }
            if (self.top_list.length > 0 || self.new_list.length > 0) {
                for (var i=tmp_shelfs.shelfs.length-1;i>=0;i--) {
                    var shelf = tmp_shelfs.shelfs[i];
                    if (shelf.title.toLowerCase().trim() == 'top / new') {
                        tmp_shelfs.shelfs.splice(i, 1);
                    }
                }
                var topNewShelf = self.constructShelfs(self.top_list.concat([{"id":"0"}]).concat(self.new_list), 'Top / New', '/b2b/images/shelf/lightbox/lightbox-top-new');
                for (var i=0;i<topNewShelf.shelfs.length;i++) {
                    tmp_shelfs.shelfs.splice(0, 0, topNewShelf.shelfs[i]);
                }
            }
            console.log('newtop', newShelf, topShelf, this.shelfs);
            for (var i = 0; i < tmp_shelfs.shelfs.length; i++) {
                var shelf = tmp_shelfs.shelfs[i];
                for (var j=shelf.layers.length-1;j>=0;j--) {
                    var isEmpty = true;
                    for (var k=0;k<shelf.layers[j].products.length;k++) {
                        var chkid = shelf.layers[j].products[k].id;
                        if (chkid != null && parseInt(chkid) > 0) {
                            isEmpty = false;
                            break;
                        }
                    }
                    if (isEmpty) shelf.layers.splice(j, 1);
                }
                if (shelf.layers.length == 0) continue;
                this.shelfs.push(shelf);
                if (shelf.layers) {
                    for (var j = 0; j < shelf.layers.length; j++) {
                        var sidx = all_products.length;
                        var layer = shelf.layers[j];
                        for (var k = 0; k < layer.products.length; k++) {
                            var p = layer.products[k];
                            p.seq = all_products.length * 10;
                            all_products.push(p);
                            if (p.id == '00') {
                                //console.log('shelf in products_in_seq', p);
                                if (p.name != null && p.banner != null) {
                                    self.products_in_seq.push(p.id+self.delimiter+p.name+self.delimiter+p.banner);
                                } else if (p.name != null) {
                                    self.products_in_seq.push(p.id+self.delimiter+p.name);
                                } else {
                                    self.products_in_seq.push(p.id)
                                }
                            } else if ((is_config == null || is_config == false) && isNaN(parseFloat(p.id))) {
                                for (var t_idx=0;t_idx<talkers.length;t_idx++) {
                                    if (p[talkers[t_idx]] != null) {
                                        self.products_in_seq.push(talkers[t_idx]+self.delimiter+p[talkers[t_idx]]);
                                    }
                                }
                                //self.products_in_seq.push(p);
                            } else {
                                self.products_in_seq.push(p.id)
                                // append end of layer
                                if ((is_config == null || is_config == false ) && k == layer.products.length - 1 && j < shelf.layers.length - 1) {
                                    self.products_in_seq.push('0');
                                }
                            }
                        }
                        if ((is_config == null || is_config == false ) && j == shelf.layers.length - 1) {
                            self.products_in_seq.push('00');
                        }
                        var eidx = all_products.length;
                        fetch_products.push([sidx, eidx]);
                    }
                }
            }
            console.log('products_in_seq after setupShelf', self.products_in_seq);
            var goto = function (idx) {
                if (idx >= fetch_products.length) {
                    self.all_loaded = true;
                    return;
                }
                self.initProductsPromise(all_products.slice(fetch_products[idx][0], fetch_products[idx][1])).then(plist => {
                    for (var i = 0; i < plist.length; i++) {
                        var p = plist[i];
                        self.$forceUpdate();
                        /*
                        if (p != null && p.width == null && p.image == null) {
                            self.loadProductImage(p).then((pimg) => {
                                p.width = pimg.width;
                                p.image = pimg.src;
                                self.$forceUpdate();
                            });
                        } else {
                            self.$forceUpdate();
                        }
                        */
                    }
                    goto(idx + 1);
                });
            }
            fetch_products.forEach((pidx, idx) => {
                var self = this;
                this.loadAllProducts(all_products.slice(pidx[0], pidx[1])).then(ps => {
                    var missing_images = [];
                    ps.forEach((p, iidx) => {
                        if (p.width == -1) {
                            //console.log('loaded', ps, JSON.stringify(all_products[pidx[0] + iidx]));
                        }
                        var pp = all_products[pidx[0] + iidx];
                        pp.width = p.width;
                        pp.image = p.src;
                        if (p.width == -1 || p.src == null || p.src.indexOf('xxx_img_')>=0) {
                            //if (pp.id == '1751' || pp.id == '2717') console.log(pp);
                            missing_images.push(pp);
                        } else {
                            if (pp.price != null) {
                                var pprice = Vue.filter('format')(pp.price);
                                pp.dollar = pprice.substring(0, pprice.indexOf('.'));
                                pp.cent = pprice.substring(pprice.indexOf('.') + 1);
                            }
                        }
                        if ((pidx[0] + iidx) == (all_products.length - 1)) {
                            this.$forceUpdate();
                            // call the function in the js/tools-b2b_shelf.js
                            initShelf();
                            const plugin = document.createElement("script");
                            plugin.setAttribute("id", "floating_js");
                            plugin.setAttribute(
                                "src",
                                "/b2b/js/tools-b2b_shelf_floating.js?" + (new Date().getTime())
                            );
                            plugin.type = "module";
                            document.head.appendChild(plugin);
                            self.all_loaded = true;
                            //self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
                        }
                    });
                    if (missing_images.length > 0) {
                        self.initProductsPromise(missing_images).then(plist => {
                            for (var i = 0; i < plist.length; i++) {
                                //if (p != null && p.width == null && p.image == null) {
                                if (plist[i] != null) {
                                    var p = plist[i];
                                    //console.log(p.id, i, p, plist, missing_images);
                                    self.loadProductImage(p).then((pimg) => {
                                        //p.width = pimg.width;
                                        //if (pimg.base64) {
                                        //    p.image = pimg.base64;
                                        //} else {
                                        //    p.image = pimg.src;
                                        //}
                                        self.$forceUpdate();
                                    });
                                } else {
                                    self.$forceUpdate();
                                }
                            }
                        });
                    }
                });
            });
            //goto(0);
        },
        init: function () {
            var self = this;
            self.shelfs = []
            //try {
            //    document.getElementById("floating_js").remove();
            //} catch (e) {
            //}
            Vue.http.get(self.products_list_url).then(
                response => {
                    //self.editing = false;
                    self.editing = self.isEditing;
                    var timewait = 1000;
                    var tmp_shelfs = JSON.parse(response.bodyText);

                    if (tmp_shelfs.shelfs == null && tmp_shelfs.productlist) {
                        tmp_shelfs = self.constructShelfs(tmp_shelfs.productlist, "Shelf");
                    }

                    var localShelfs = localStorage.getItem("shelf");
                    if (localShelfs != null) {
                        // load from local
                        tmp_shelfs = JSON.parse(localShelfs);
                    }

                    if (self.all_products_list != null) {
                        var all_p_list = self.all_products_list.map(p => p.id);
                        var np = [];
                        for (var i=self.all_products_list.length-1;i>=0;i--) {
                            var found = false;
                            var pp = self.all_products_list[i];
                            for (var s=0;s<tmp_shelfs.shelfs.length;s++) {
                                var shelf = tmp_shelfs.shelfs[s];
                                for (var l=0;l<shelf.layers.length;l++) {
                                    var layer = shelf.layers[l];
                                    for (var p=layer.products.length-1;p>=0;p--) {
                                        var product = layer.products[p];
                                        if ((pp) == product.id || (pp.id) == product.id) {
                                            product.pwidth = pp.width;
                                            product.pheight = pp.height;
                                            product.stock = pp.stock;
                                            product.price = pp.price;
                                            found = true;
                                            break;
                                        } else if (product.id != null && !all_p_list.includes((product.id))) {
                                            layer.products.splice(p, 1);
                                            break;
                                        }
                                    }
                                    if (found) break;
                                }
                                if (found) break;
                            }
                            if (!found) np.push(pp);
                        }
                        console.log(tmp_shelfs, np);
                        // no show the new product first
                        if (self.editing && np.length > 0) {
                            self.initProductsPromise(np.map((p) => ({"id":p.id}))).then(nplist => {
                                var new_shelfs = self.constructShelfs(nplist, "Not Listed");
                                tmp_shelfs.shelfs = new_shelfs.shelfs.concat(tmp_shelfs.shelfs);
                                self.setupShelfs(tmp_shelfs);
                            });
                        } else {
                            if (np.length > 0) {
                                console.log("Products found in the b2b but no on the shelfs", np);
                            }
                            self.setupShelfs(tmp_shelfs);
                        }
                    } else {
                        self.setupShelfs(tmp_shelfs);
                    }
                },
                response => {
                    var tmp_shelfs = self.constructShelfs(self.all_products_list, "Shelf");
                    self.setupShelfs(tmp_shelfs, true);
                    //self.products_list_url = utils.getServerPath() + '/product/' + "search.is?only_id=true&product_name=&start=" + 0 + "&num=" + 2000;
                    //self.init();
                }
            );
        },
        doneMoved: function (evt, product) {
            console.log(evt, product);
        },
        getProductJSON: function (p) {
            return { "id": p.id, "imgname": p.imgname, "image": p.image, "width": p.width, "seq": p.seq, "pwidth": p.pwidth, "pheight": p.pheight, "shelf_obj":p.shelf_obj, "price":p.price };
        },
        downloadShelf: function (evt, shelf) {
            var self = this;
            var s = {};
            Object.keys(shelf).forEach(key => {
                if (key == 'layers') {
                    s['layers'] = []
                    var layers = shelf[key];
                    for (var i = 0; i < layers.length; i++) {
                        var l = { 'products': [] }
                        for (var j = 0; j < layers[i].products.length; j++) {
                            l.products.push(self.getProductJSON(layers[i].products[j]));
                            //l.products.push({ "id": layers[i].products[j].id, "imgname": layers[i].products[j].imgname });
                        }
                        s['layers'].push(l);
                    }
                } else {
                    s[key] = shelf[key];
                }
            });
            utils.download("shelf.txt", JSON.stringify(s));
        },
        downloadLayer: function (evt, layer) {
            var l = {
                "products": []
            }
            for (var i = 0; i < layer.products.length; i++) {
                //l.products.push({ "id": layer.products[i].id, "imgname": layer.products[i].imgname });
                l.products.push(self.getProductJSON(layer.products[i]));
            }
            utils.download("layer.txt", JSON.stringify(l));
        },
        previewFile: function (file, func, converter_url) {
            let reader = new FileReader()
            console.log('previewFile', file);
            if (file.type.indexOf('text') >= 0) {
                reader.readAsText(file);
            } else if (file.type.indexOf('json') >= 0) {
                reader.readAsText(file);
            } else {
                reader.readAsDataURL(file);
            }
            reader.onloadend = function () {
                var b64 = reader.result;
                var base64_str = ';base64,';
                var base64_idx = b64.indexOf(base64_str);
                if (converter_url != null && base64_idx > 0) {
                    b64 = b64.substring(base64_idx+base64_str.length)
                    console.log(b64);
                    var req_body = {"opr":"to_json", "value":b64};
                    Vue.http.post(converter_url, req_body, {
                        headers: {
                            'Content-Type': 'application/json',
                            // You can add additional headers if needed
                        }
                    }).then(response => {
                        console.log(response.body);
                        if (func) func(JSON.stringify(response.body));
                    }).catch(error => {
                        console.error('Error:', error);
                        // Handle errors here
                    });
                } else {
                    if (func) func(reader.result);
                }
            }
        },
        setProduct: function (ev, oproduct, shelf_idx, layer_idx, product_idx) {
            var self = this;
            self.processFile(ev, function (res) {
                console.log(res);
            });
        },
        setLayerProduct: function (ev, olayer, shelf_idx, layer_idx) {
            var self = this;
            self.processFile(ev, function (res) {
                try {
                    var l = JSOn.parse(res);
                    if (l.products != null) {
                        console.log('layer', olayer, l, shelf_idx, layer_idx);
                        var localShelfs = self.getLocalShelfs();
                        localShelfs.shelfs[shelf_idx].layers[layer_idx] = s;
                        localStorage.setItem("shelf", JSON.stringify(localShelfs));
                        self.init();
                    } else if (l.id != null) {
                        var localShelfs = self.getLocalShelfs();
                        localShelfs.shelfs[shelf_idx].layers[layer_idx].products.push(s);
                        localStorage.setItem("shelf", JSON.stringify(localShelfs));
                        self.init();
                    }
                } catch (e) { }
            });
        },
        processFile: function (ev, func, converter_url) {
            var self = this;
            if (ev.dataTransfer.items) {
                // Use DataTransferItemList interface to access the file(s)
                [...ev.dataTransfer.items].forEach((item, i) => {
                    // If dropped items aren't files, reject them
                    if (item.kind === "file") {
                        const file = item.getAsFile();
                        self.previewFile(file, func, converter_url);
                    }
                });
            } else {
                // Use DataTransfer interface to access the file(s)
                [...ev.dataTransfer.files].forEach((file, i) => {
                    self.previewFile(file, func, converter_url);
                });
            }
        },
        getLocalShelfs: function () {
            var self = this;
            var localShelfs = localStorage.getItem("shelf");
            if (localShelfs == null) {
                localShelfs = { 'shelfs': [] }
                for (var i = 0; i < self.shelfs.length; i++) {
                    var shelf = self.shelfs[i];
                    var tmpshelf = { 'layers': [] };
                    localShelfs.shelfs.push(tmpshelf);
                    Object.keys(shelf).forEach(key => {
                        if (key == 'layers') {
                            for (var j = 0; j < shelf.layers.length; j++) {
                                var layer = shelf.layers[j];
                                var l = { 'products': [] };
                                tmpshelf.layers.push(l);
                                for (var k = 0; k < layer.products.length; k++) {
                                    l.products.push(self.getProductJSON(layer.products[k]));
                                    //l.products.push({ "id": layer.products[k].id, "imgname": layer.products[k].imgname });
                                }
                            }
                        } else {
                            tmpshelf[key] = shelf[key];
                        }
                    });
                }
            } else {
                localShelfs = JSON.parse(localShelfs);
            }
            //localStorage.setItem("shelf", JSON.stringify(localShelfs));
            return localShelfs;
        },
        downloadShelfsXls: function (ev) {
            var self = this;
            if (!self.editing) return;
            //const jsonString = JSON.stringify(self.shelfs);
            //console.log('json size', jsonString.length);
            //const utf8Bytes = new TextEncoder().encode(jsonString);
            //const base64 = btoa(String.fromCharCode.apply(null, utf8Bytes));
            //const base64 = btoa(String.fromCharCode(...utf8Bytes));

            //console.log(base64);
            var req_body = {"opr":"to_xlsx", "value":self.shelfs};
            Vue.http.post("https://apps.sampsonstore.com/hub/apiproxy/b2b/shelfs_xls_json", req_body, {
                headers: {
                    'Content-Type': 'application/json',
                    // You can add additional headers if needed
                }
            }).then(response => {
                console.log(response.body);
                var base64String = response.body.base64;
                const decodedData = atob(base64String);
                // Convert the decoded data to a Uint8Array
                const arrayBuffer = new Uint8Array(decodedData.length);
                for (let i = 0; i < decodedData.length; i++) {
                    arrayBuffer[i] = decodedData.charCodeAt(i);
                }
                // Create a Blob from the Uint8Array
                const blob = new Blob([arrayBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

                // Create a link element to download the Excel file
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = 'planogram.xlsx';

                // Append the link to the document
                document.body.appendChild(link);

                // Trigger a click event on the link to initiate the download
                link.click();

                // Remove the link from the document (optional)
                document.body.removeChild(link);

            }).catch(error => {
                console.error('Error:', error);
                // Handle errors here
            });
        },
        downloadProductsSeq: function (ev) {
            var self = this;
            if (self.editing) {
                //utils.download("products_in_seq.txt", JSON.stringify(self.products_in_seq));
                utils.download("products_in_seq.txt", self.products_in_seq.join('\r\n'));
            }
        },
        downloadShelfs: function (ev) {
            var self = this;
            utils.download("planogram.json", JSON.stringify(self.getLocalShelfs()));
            localStorage.removeItem("shelf");
        },
        setProductsSeq: function (ev) {
            var self = this;
            self.processFile(ev, function (res) {
                var shelfs_info = null;
                console.log('setProductsSeq', res);
                try {
                    shelfs_info = JSON.parse(res)
                    console.log('setProductsSeq', shelfs_info);
                } catch (e) {}
                var seqs = null;
                if (shelfs_info != null) {
                    seqs = self.convertJSONToSeq(shelfs_info);
                } else {
                    seqs = res.split('\n').map((x) => x.trim());
                }
                console.log('setProductsSeq', seqs);
                //var seqs = JSON.parse(res);
                var list = [];
                var not_found = [];
                for (var i=0;i<seqs.length;i++) {
                    var ids = seqs[i].split(self.delimiter);
                    if (ids[0].startsWith('00')) {
                        //list.push({'id':seqs[i]});
                        var shelf = {'id':'00'};
                        if (ids.length > 1) {
                            shelf.name = ids[1];
                        }
                        if (ids.length > 2) {
                            shelf.banner = ids[2];
                        }
                        list.push(shelf);
                        continue;
                    } else if (ids[0] == '0') {
                        // layer break
                        list.push({'id':ids[0]});
                        continue;
                    } else if (isNaN(parseFloat(ids[0]))) {
                        list.push(seqs[i]);
                    //} else if (seqs[i] == '00') {
                        // shelf break
                    //    list.push({'id':seqs[i]});
                    //    continue;
                    }
                    var found = false;
                    for (var s=0;s<self.shelfs.length;s++) {
                        var shelf = self.shelfs[s];
                        for (var l=0;l<shelf.layers.length;l++) {
                            var layer = shelf.layers[l];
                            for (var p=0;p<layer.products.length;p++) {
                                var product = layer.products[p];
                                //for (var i=0;i<seqs.length;i++) {
                                    //if (seqs[i] == product.id) {
                                    if (ids[0] == product.id) {
                                        if (product.pwidth != null) {
                                            product.width = product.pwidth;
                                        } else if (product.width != null) {
                                            //product.pwidth = product.width / self.width_to_pixel;
                                            product.width = product.width / self.width_to_pixel;
                                            product.pwidth = null;
                                        }
                                        //console.log(JSON.stringify(product));
                                        product.seq = i;
                                        list.push(product);
                                        found = true;
                                        break;
                                    }
                                //}
                            }
                            if (found) break;
                        }
                        if (found) break;
                    }
                    if (!found && ids[0].length > 0 && talkers.indexOf(ids[0]) < 0) {
                        not_found.push(ids[0]);
                    }
                }
                if (not_found.length > 0) {
                    alert("Products not found, please make sure the products are in b2b product master:"+not_found);
                    console.log("Products not found, please make sure the products are in b2b product master:", not_found);
                }
                //console.log(JSON.stringify(list));
                list.sort((x, y) => {
                    if (x.seq < y.seq) return -1;
                    if (x.seq > y.seq) return 1;
                    return 0;
                });
                //console.log(JSON.stringify(list));
                self.shelfs = []
                s = self.constructShelfs(list, "Shelf");
                self.setupShelfs(s);
                //console.log(s);
                utils.download("planogram.json", JSON.stringify({"shelfs":self.shelfs}));
            }, "https://apps.sampsonstore.com/hub/apiproxy/b2b/shelfs_xls_json");
        },
        setShelfs: function (ev) {
            var self = this;
            self.processFile(ev, function (res) {
                var s = JSON.parse(res);
                if (s.shelfs != null) {
                    localStorage.setItem("shelf", JSON.stringify(s));
                    self.init();
                } else if (s.layers != null) {
                    var localShelfs = self.getLocalShelfs();
                    localShelfs.shelfs.push(s);
                    localStorage.setItem("shelf", JSON.stringify(localShelfs));
                    self.init();
                }
            });
        },
        setShelfProduct: function (ev, oshelf, idx) {
            var self = this;
            self.processFile(ev, function (res) {
                try {
                    var s = JSON.parse(res);
                    if (s.layers != null) {
                        console.log('shelf', oshelf, s, idx);
                        var localShelfs = self.getLocalShelfs();
                        localShelfs.shelfs[idx] = s;
                        localStorage.setItem("shelf", JSON.stringify(localShelfs));
                        self.init();
                    } else if (s.products != null) {
                        var localShelfs = self.getLocalShelfs();
                        localShelfs.shelfs[idx].layers.push(s);
                        localStorage.setItem("shelf", JSON.stringify(localShelfs));
                        self.init();
                    }
                } catch (e) {
                    console.log(e);
                }
            });
        },
        initProductsPromise: function (products) {
            var self = this;
            return new Promise((resolve, reject) => {
                if (products == null || products.length == 0) {
                    resolve([]);
                    return;
                }
                var url = "search.is?";
                for (var i = 0; i < products.length; i++) {
                    if (products[i].id != null) {
                        url = url + '&product_id=' + products[i].id;
                    }
                }
                if (url.indexOf('&') < 0) {
                    resolve([]);
                    return;
                }
                Vue.http.get(utils.getServerPath() + '/product/' + url).then(response => {
                    var ps = response.body.productlist;
                    var out = [];
                    if (ps.length > 0) {
                        for (var i = 0; i < ps.length; i++) {
                            for (var j = 0; j < products.length; j++) {
                                var product = products[j];
                                if (ps[i].pdetails.product_id == product.id) {
                                    product.pdetails = ps[i].pdetails;
                                    //console.log(product.id, JSON.stringify(product), JSON.stringify(ps[i]));
                                    if (!product.width || product.width == -1) product.width = parseFloat(ps[i].pdetails.width) * self.width_to_pixel;
                                    if (!product.height) product.height = parseFloat(ps[i].pdetails.height);
                                    //product.width = ps[i].pdetails.width;
                                    //product.height = ps[i].pdetails.height;
                                    if (ps[i].shelf_obj) product.shelf_obj = ps[i].shelf_obj;
                                    else product.shelf_obj = ps[i].img_tag2;
                                    //product.shelf_obj = ps[i].shelf_obj;
                                    //product.img_tag2 = ps[i].img_tag2;
                                    product.wbuym = ps[i].wbuym;
                                    product.wfreen = ps[i].wfreen;
                                    product.price = ps[i].wprice;
                                    product.stock = ps[i].stock;
                                    var pprice = Vue.filter('format')(parseFloat(product.price));
                                    product.dollar = pprice.substring(0, pprice.indexOf('.'));
                                    product.cent = pprice.substring(pprice.indexOf('.') + 1);
                                    out.push(product);
                                }
                            }
                        }
                    }
                    resolve(out);
                });
            });
        },
        initProduct: function (p, f) {
            var self = this;
            try {
                if (p != null && f != null) {
                    self.products_loading.push([p, f]);
                    return;
                }
            } catch (e) {
                self.products_loading = []
                if (p != null && f != null) self.products_loading.push([p, f]);
            }
            if (self.products_loading.length == 0) {
                self.products_loading = null;
                return;
            }
            var product_info = self.products_loading[0];
            var product = product_info[0];
            var func = product_info[1];
            if (self.products_loaded.indexOf(product.id+'.png') >= 0) {
                self.products_loading.shift();
                self.initProduct();
                return;
            }
            var url = "search.is?product_id=" + product.id;
            Vue.http.get(utils.getServerPath() + '/product/' + url).then(response => {
                if (response.body.productlist.length > 0) {
                    //console.log(response.body.productlist);

                    product = response.body.productlist[0];

                    product.pdetails = response.body.productlist[0].pdetails;
                    product.wbuym = response.body.productlist[0].wbuym;
                    product.shelf_obj = response.body.productlist[0].shelf_obj;
                    product.wfreen = response.body.productlist[0].wfreen;
                    product.price = response.body.productlist[0].wprice;
                    product.stock = response.body.productlist[0].stock;
                    var pprice = Vue.filter('format')(parseFloat(product.price));
                    product.dollar = pprice.substring(0, pprice.indexOf('.'));
                    product.cent = pprice.substring(pprice.indexOf('.') + 1);
                    if (func) func(product);
                }
                self.products_loaded.push(product.id);
                self.products_loading.shift();
                if (self.products_loading.length == 0) self.products_loading = null;
                else if (self.products_loading.length > 0) self.initProduct();
            }, err => {
                self.initProduct();
            });
        },
        touchProduct: function (product) {
            var self = this;
            if (self.check_display) return;
            //console.log("touching ...", product);
            if (((product.pdetails == null || product.pdetails.price == null) && product.id != null)) {
                self.showing_product.is_loading = true;
                self.$forceUpdate();
                if (self.touching != null) clearTimeout(self.touching);
                self.touching = setTimeout(() => {
                    self.initProduct(product, function (p) {
                        self.showing_product.is_loading = false;
                        //console.log('init p', p);
                        if (p.pdetails) {
                            self.showing_product.pdetails = p.pdetails;
                            self.showing_product.price = p.price;
                            self.showing_product.wbuym = p.wbuym;
                            self.showing_product.shelf_obj = p.shelf_obj;
                            self.showing_product.wfreen = p.wfreen;
                            self.showing_product.stock = p.stock;

                            self.showing_product = p;
                            Object.keys(self.showing_product).forEach(function(key) {
                                product[key] = self.showing_product[key];
                            });

                            var oqty = self.getCartQty(self.showing_product);
                            self.$root.$emit('setQty', { oqty: oqty });
                        }
                    });
                    self.$forceUpdate();
                }, 1000);
                /*
                var url = "search.is?product_id=" + product.id;
                Vue.http.get(utils.getServerPath() + '/product/' + url).then(response => {
                    console.log(response.body.productlist);
                    product.pdetails = response.body.productlist[0].pdetails;
                    product.wbuym = response.body.productlist[0].wbuym;
                    product.wfreen = response.body.productlist[0].wfreen;
                    product.stock = response.body.productlist[0].stock;
                    var pprice = Vue.filter('format')(parseFloat(product.pdetails.price));
                    product.dollar = pprice.substring(0, pprice.indexOf('.'));
                    product.cent = pprice.substring(pprice.indexOf('.') + 1);
        
                    self.showing_product.pdetails = product.pdetails;
                    self.showing_product.wbuym = product.wbuym;
                    self.showing_product.wfreen = product.wfreen;
                    self.showing_product.stock = product.stock;
                    self.$forceUpdate();
                });*/
            } else {
                var p = product;
                if (p.pdetails) {
                    self.showing_product = {};
                    self.showing_product.pdetails = p.pdetails;
                    //self.showing_product.price = p.price;
                    self.showing_product.wprice = p.price;
                    self.showing_product.shelf_obj = p.shelf_obj;
                    self.showing_product.wbuym = p.wbuym;
                    self.showing_product.wfreen = p.wfreen;
                    self.showing_product.stock = p.stock;
                    //self.showing_product = p;
                    //console.log('touch product', self.showing_product);
                    var oqty = self.getCartQty(self.showing_product);
                    self.$root.$emit('setQty', { oqty: oqty });
                    if (product.img_tag2 == null) {
                        // reset the price to 0
                        self.showing_product.pdetails.price = 0;
                        self.showing_product.is_loading = true;
                        self.$forceUpdate();
                        if (self.touching != null) clearTimeout(self.touching);
                        self.touching = setTimeout(() => {
                            self.initProduct(product, function (p) {
                                self.showing_product.is_loading = false;
                                if (p.pdetails) {
                                    self.showing_product = p;
                                    Object.keys(self.showing_product).forEach(function(key) {
                                        product[key] = self.showing_product[key];
                                    });
                                    //var oqty = self.getCartQty(self.showing_product);
                                    //self.$root.$emit('setQty', { oqty: oqty });
                                }
                                self.$forceUpdate();
                            });
                        }, 1000);
                    } else {
                        self.showing_product = p;
                    }
                    self.$forceUpdate();
                }
            }
            //this.floating_price = price;
        },
        checkLoaded:function() {
            if (this.loaded[1] < 0) return;
            var self = this;
            self.loaded[1]++;
            //if (self.loaded/self.all_products_list.length > 0.5) {
            if (self.loaded[1] > 0 && self.loaded[1]/self.loaded[0] > 0.7) {
                console.log('loaded done', self.loaded);
                self.loaded[1] = -1;
                setTimeout(function() {
                    self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
                }, 100);
            }
        },
        loadProductImage: function (product) {
            var self = this;
            return new Promise((resolve, reject) => {
                const image = new Image();
                //product.img = image;
                image.onload = () => {
                    self.checkLoaded();
                    /**
                    if (product.is_new == '1') {
                        for (var i=0;i<self.shelfs.length;i++) {
                            var shelf = self.shelfs[i];
                            if (shelf.is_new) {
                                for (var j=0;j<shelf.layers.length;j++) {
                                    var layer = shelf.layers[j];
                                    for (var k=0;k<layer.products.length;k++) {
                                        var p = layer.products[k];
                                        if (p.id == product.id) {
                                            layer.products[k] = product;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (product.is_top != '') {
                        for (var i=0;i<self.shelfs.length;i++) {
                            var shelf = self.shelfs[i];
                            if (shelf.is_top) {
                                for (var j=0;j<shelf.layers.length;j++) {
                                    var layer = shelf.layers[j];
                                    for (var k=0;k<layer.products.length;k++) {
                                        var p = layer.products[k];
                                        if (p.id == product.id) {
                                            layer.products[k] = product;
                                        }
                                    }
                                }
                            }
                        }
                    }
                     */
                    if (image.src.indexOf(product.id+PRODUCT_IMG_EXT) >= 0) {
                        //console.log('load image', product.id, image.src);
                    } else {
                        /*
                        const canvas = document.createElement('canvas');
                        canvas.width = image.width;
                        canvas.height = image.height;
                        const ctx = canvas.getContext('2d');
                        ctx.drawImage(image, 0, 0);

                        const base64 = canvas.toDataURL('image/png');
                        product.image = base64;
                        canvas.remove();
                        */
                        if (isNaN(product.width) || product.width == null || product.width <= 5) {
                            //console.log(product.id, JSON.stringify(product));
                            product.width = 200 * self.width_to_pixel;
                        }
                        //resolve({'base64':base64, 'width':product.width});
                        product.image = image.src;
                        resolve({'base64':image.src, 'width':product.width});
                        return;
                    }

                    if (product.width != null && product.width > 1) {
                        product.image = image.src;
                        if ((parseFloat(product.pwidth) > parseFloat(product.pheight) && image.width < image.height) || parseFloat(product.pwidth) < parseFloat(product.pheight) && image.width > image.height) {
                            console.log('orientation miss matched', product.id, 'db:'+product.pwidth+','+product.pheight, 'image:'+image.width+','+image.height);
                        }
                        resolve({ 'src': image.src, 'width': product.width });
                    } else {
                        product.image = image.src;
                        if ((parseFloat(product.pwidth) > parseFloat(product.pheight) && image.width < image.height) || parseFloat(product.pwidth) < parseFloat(product.pheight) && image.width > image.height) {
                            console.log('orientation miss matched', product.id, 'db:'+product.pwidth+','+product.pheight, 'image:'+image.width+','+image.height);
                        }
                        //product.width = image.width;
                        //resolve({ 'src': image.src, 'width': product.width });
                        resolve(image);
                    }
                }
                image.onerror = (error) => {
                    self.checkLoaded();
                    //console.log('image not found', product, error);
                    if (image.src.indexOf(product.id+PRODUCT_IMG_EXT) >= 0) {
                        self.missing_images.push(product.id);
                        //console.log(self.missing_images);
                        if (product.image) {
                            image.src = product.image;
                        } else if (product.shelf_obj != null) {
                            image.src = product.shelf_obj;
                        } else {
                            //console.log('missing image', JSON.stringify(product));
                            resolve({'width':-1});
                        }
                    } else {
                        //console.log("missing id image ?", ':'+image.src+':');
                        image.src = '/shop/sh88/mmobj/xxx_img_enus_400x400.gif'
                        //console.log("missing id image ?", ':'+image.src+':');
                    }
                    //resolve({'src':product.image, 'width':product.width});
                }
                // no need to load the image if info retrieved
                if (product.image != null && product.width != null) {
                    resolve({ 'src': product.image, 'width': product.width });
                } else {
                    self.loaded[0]++;
                    product.img = image;
                    if (product.shelf_obj != null) {
                        image.src = product.shelf_obj;
                    } else if (true) {
                        //image.src = "https://www.sampsonstore.com/b2b/images/shelf/products-id/" + product.id + PRODUCT_IMG_EXT;
                        image.src = "https://www.sampsonstore.com/b2b/images/shelf/products-id/webp/" + product.id + PRODUCT_IMG_EXT;
                    } else if (product.shelf_obj != null) {
                        // it is the image of large_img_id4 in cms
                        image.src = product.shelf_obj;
                    } else if (product.imgname == null) {
                        image.src = "/b2b/images/shelf/products-id/" + product.id + ".png";
                    } else {
                        image.src = "/b2b/images/shelf/products/" + product.imgname + ".png";
                    }
                }
            });
        },
        loadAllProducts: function (products) {
            const promises = products.map((product) => this.loadProductImage(product));
            return Promise.all(promises);
        }
    },
    mounted: function () {
        var self = this;
        if (window.location.href.indexOf('/pog/') > 0) {
            Vue.cookie.set('pmode', 'shelf');
            if (!self.isPog) {
                window.location.href = '../product/index.html'
                return;
            }
        }
        var num = 2000;
        var start = 0;
        var url = "search.is?time="+(new Date().getTime())+"&only_id=true&product_name=&start=" + start + "&num=" + num;
        self.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.common_res.message.waiting});
        Vue.http.get(utils.getServerPath() + '/product/' + url).then(response => {
            //self.all_products_list = response.body.productlist;
            //self.all_products_list = response.body.productlist.map((p) => p.id?parseInt(p.id):p);
            self.all_products_list = response.body.productlist.map((p) => p);
            console.log(self.all_products_list);
            for (var i=0;i<self.all_products_list.length;i++) {
                var pp = self.all_products_list[i];
                if (pp['is_new'] == '1') {
                    var createdate = pp['create_date'];
                    console.log(pp);
                    var createdate_str = "new|"+createdate.split('-')[0] + ' ' + months[createdate.split('-')[1]]+createdate.split('-')[2]
                    var idx = -1;
                    for (var j=0;j<self.new_list.length;j++) {
                        if (createdate_str == self.new_list[j].id) {
                            idx = j;
                            break;
                        }
                    }
                    if (idx == -1) {
                        // find the right position to add
                        idx = 0;
                        for (var j=0;j<self.new_list.length;j++) {
                            if (self.new_list[j].date != null && createdate > self.new_list[j].date) {
                                idx = j;
                                break;
                            }
                        }
                        self.new_list.splice(idx, 0, {"id":"placeholder|5"});
                        self.new_list.splice(idx, 0, pp);
                        self.new_list.splice(idx, 0, {"id":createdate_str, "date":createdate});
                    } else {
                        var iidx = -1;
                        for (var j=idx+1;j<self.new_list.length;j++) {
                            if (self.new_list[j].id.startsWith("placeholder|")) {
                                iidx = j;
                                break;
                            }
                        }
                        if (iidx == -1) self.new_list.push(pp);
                        else self.new_list.splice(iidx, 0, pp);
                    }
                }
                if (pp['is_top'] != '') {
                    idx = self.top_list.length;
                    var topvar = parseInt(pp.is_top);
                    for (var j=0;j<self.top_list.length;j++) {
                        if (self.top_list[j].id.startsWith("top|")) {
                            var itemvar = parseInt(self.top_list[j].id.substring(4));
                            if (topvar > itemvar) {
                                idx = j;
                                break;
                            }
                        }
                    }
                    self.top_list.splice(idx + 0, 0, {"id":"top|" + topvar});
                    self.top_list.splice(idx + 1, 0, pp);
                    self.top_list.splice(idx + 2, 0, pp);
                    self.top_list.splice(idx + 3, 0, {"id":"placeholder|5"});

                    /*
                    idx = self.top_list.length;
                    var topvar = parseInt(pp.is_top) + 5;
                    for (var j=0;j<self.top_list.length;j++) {
                        if (self.top_list[j].id.startsWith("top|") && ("top|"+topvar) < self.top_list[j].id) {
                            idx = j;
                            break;
                        }
                    }
                    self.top_list.splice(idx + 0, 0, {"id":"top|" + topvar});
                    self.top_list.splice(idx + 1, 0, pp);
                    self.top_list.splice(idx + 2, 0, pp);
                    self.top_list.splice(idx + 3, 0, {"id":"placeholder|5"});

                    idx = self.top_list.length;
                    var topvar = parseInt(pp.is_top) + 3;
                    for (var j=0;j<self.top_list.length;j++) {
                        if (self.top_list[j].id.startsWith("top|") && ("top|"+topvar) < self.top_list[j].id) {
                            idx = j;
                            break;
                        }
                    }
                    self.top_list.splice(idx + 0, 0, {"id":"top|" + topvar});
                    self.top_list.splice(idx + 1, 0, pp);
                    self.top_list.splice(idx + 2, 0, pp);
                    self.top_list.splice(idx + 3, 0, {"id":"placeholder|5"});

                    idx = self.top_list.length;
                    var topvar = parseInt(pp.is_top) + 2;
                    for (var j=0;j<self.top_list.length;j++) {
                        if (self.top_list[j].id.startsWith("top|") && ("top|"+topvar) < self.top_list[j].id) {
                            idx = j;
                            break;
                        }
                    }
                    self.top_list.splice(idx + 0, 0, {"id":"top|" + topvar});
                    self.top_list.splice(idx + 1, 0, pp);
                    self.top_list.splice(idx + 2, 0, pp);
                    self.top_list.splice(idx + 3, 0, {"id":"placeholder|5"});

                    for (var j=0;j<self.top_list.length;j+=4) {
                        self.top_list[j] = {"id":"top|" + ((j/4)+1)};
                    }
                    */
                }
            }
            self.init();
        });
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ProductShelf.vue